import React, { Fragment, useEffect } from "react";
import { useForm, useFormContext, useWatch } from "react-hook-form";
import { Input, FormFeedback, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

import "../../../scss/dashboard/abogadosForm.css";
import { Link, useHistory } from "react-router-dom";
import { useCategoryList } from "../../../api/hooks/categories";

const EditConfig = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { data, isLoading } = useCategoryList({
    keepPreviousData: true,
  });
  // const [checkboxCount, setCheckboxCount] = React.useState(0);
  const { register, errors } = useFormContext({ mode: "all" });

  return (
    <div className="abogados-form">
      <div className="abogadosForm__section1">
        <h2>Categoria</h2>
        {data?.data?.map((category) => (
          <label>
            <Input
              type="checkbox"
              className="formAbogadosConfig"
              name="categories"
              value={category._id}
              invalid={!!errors?.categories?.message}
              innerRef={register()}
            ></Input>
            {category.name}
          </label>
        ))}
        {isLoading && (
          <div>
            <Spinner />
          </div>
        )}
        <small className="text-danger" hidden={!errors?.categories?.message}>
          {t(`errors.${errors?.categories?.message}`)}
        </small>
      </div>
      <div
        className="abogados__config--price--step2"
        style={{ position: "relative" }}
      >
        <h2>Precio</h2>
        <label>Cantidad</label>
        <div
          style={{
            height: "28px",
            position: "relative",
          }}
        >
          <span
            style={{
              position: "absolute",
              left: "4px",
              bottom: -4,
              fontWeight: "bold",
              fontFamily: "Roboto",
              fontSize: "18px",
            }}
          >
            $
          </span>

          <Input
            name="price"
            type="number"
            min={0}
            invalid={!!errors?.price?.message}
            // className={errors.Precio ? "formAbogados__notValidInput" : ""}
            style={{ paddingLeft: "15px" }}
            innerRef={register}
          ></Input>
          <FormFeedback>{t(`errors.${errors?.price?.message}`)}</FormFeedback>
        </div>
      </div>
      <button
        type="submit"
        // disabled={!isValid}
        style={{ marginLeft: "9%" }}
        onClick={onSubmit}
        className={"btn-accent-100 btn abogadosForm__button--1"}
      >
        Guardar
      </button>
    </div>
  );
};

export default EditConfig;
